import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar} from '@angular/material';
import {environment} from '../../environments/environment';
import {ConnecttocrudService} from '../connecttocrud.service';
import {KongService} from '../kong.service';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {DomSanitizer} from '@angular/platform-browser';
import {DialogData} from '../partner-onboard/partner-onboard.component';
import {Location} from '@angular/common';
import {AppComponent} from '../app.component';
import { DialogComponent } from '../shared/dialog/dialog.component';
import {ListenerService} from '../listener.service';
import {AttributeDescriptionComponent} from '../crudapi/crudapi.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';


export interface ICategory {
  name: string;
}

export interface EntityVersions {
  name: string;
}
export interface MethodTypes {
  id: string;
  itemName: string;
}

declare let $;
const incr = 5;


@Component({
  selector: 'app-jsontoapi',
  templateUrl: './jsontoapi.component.html',
  styleUrls: ['./jsontoapi.component.scss']
})
export class JsontoapiComponent implements OnInit {

  myControl = new FormControl();
  progress = 0;
  progressMessage: string;
  apiCategory: string;
  tableName: string;
  tableLabelName = 'Table Name';
  version: string;
  entityName: any;
  countPartnerEntities: any;
  countPartnerAccountEntities: any;
  displayName: string;
  attributeName: string;
  description: string;
  required: boolean;
  importDataDB: boolean;
  listofTables: boolean;
  useReferentialKeys: boolean;
  databaseName: string;
  targetDatabase: string;
  APILoading = false;
  buttonClick = false;
  APILoadingdB = false;
  buttonClickdB = false;
  save: boolean;
  error = true;
  flag: any;
  flagValue = true;
  errorMessage: any;
  dberror = true;
  loading = false;
  Blocks = [];
  destroy: any;
  entityAndVersion: any;
  BlockList = {
    '1': 0,
    '2': 25,
    '3': 50,
    '4': 75,
    '5': 100
  };
  apiByDefinition = [{
    'customType': false,
    'apiAccessPolicy': 'None',
    'attributeName': null,
    'type': null,
    'array': false,
    'size': null,
    'precision': null,
    'autoIncrement': false,
    'defaultValue': null,
    'attributeType': 'None',
    'dataStoragePolicy': 'None',
    'description': null,
    'displayName': null,
    'displayPolicy': 'None',
    'required': false,
    'subType': []

  }];
  authModel: any;
  headers = [];
  queryParams = [];
  requestBody: any;
  prerequisites: any;

  filteredOptions: Observable<ICategory[]>;
  entityVersions: EntityVersions[] = [
    {name: 'v1'},
    {name: 'v2'},
    {name: 'v3'},
    {name: 'v4'},
    {name: 'v5'},
    {name: 'v6'},
    {name: 'v7'},
    {name: 'v8'},
    {name: 'v9'},
    {name: 'v10'}
  ];

  settings = {
    text: 'Select API Method Types *',
    // selectAllText: 'Select All',
    // unSelectAllText: 'Unselect All',
    enableSearchFilter: true,
    autoPosition: false
  };
  // methodType: string;
  methodTypes: MethodTypes[] = [
    {id: 'GET', itemName: 'GET'},
    {id: 'PUT', itemName: 'PUT'},
    {id: 'POST', itemName: 'POST'},
    {id: 'DELETE', itemName: 'DELETE'},
    {id: 'PATCH', itemName: 'PATCH'}
  ];

  methodType =  [];

  selectDatabase: string;
  selectGateway = 'default';
  ispublished = true;
  databases: any;
  gateways = [
    {gateway_name: 'default',
      gateway_type: 'apiplatform'
    }
  ];
  datatypes: any;
  dataTypeFilter: any;
  selectedDatatypeFilter: string;
  options: any;
  url = environment.konghost;
  attributes = ['None', 'Primary', 'Unique'];
  data = ['String',
    'Integer',
    'Date',
    'Double',
    'Timestamp',
    'Boolean',
    'Array',
    'Array Of Strings',
    'Object',
    'ObjectId'
  ];
  importData: boolean;
  scope = [{'displayName': 'Public', 'value': 'public'},
    {'displayName': 'Private', 'value': 'private'}];
  scopeSelected = 'public';
  account = new FormControl();
  accounts = ['default'];
  partner = localStorage.getItem('partner');
  partnerKey = localStorage.getItem('partnerKey');
  account_id = localStorage.getItem('account');
  gatewayUrl: any;
  gatewayFullUrl: string;
  // = (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
  apiKey = localStorage.getItem('apikey');
  showNextPanel = false;
  angular: any;
  accept = false;

  servicedata: any;
  routehostdata: any;
  routepathdata: any;
  ratelimitingOrig: any;
  keyauthOrig: any;
  // entities: any;
  // entityTypes = [];
  enableBlockly = false;
  jwtOrig: any;
  ipRestriction: any;
  isSpecialCharacterInAttribute = false;
  dataTypeArray: any;
  // customType = false;

  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;

  options1 = new JsonEditorOptions();
  JSONdata = [{
    'apiAccessPolicy': 'string',
    'attributeName': 'string',
    'type': null,
    'size': null,
    'precision': null,
    'autoIncrement': false,
    'defaultValue': null,
    'attributeType': 'string',
    'dataStoragePolicy': 'string',
    'description': 'string',
    'displayName': 'string',
    'displayPolicy': 'string',
    'required': false,
    'subType': []

  }];
  yamlData: any;
  hideBreadcrumb = false;
  route: any;
  enableMonacoEditor = false;

  constructor(private confPost: ConfService,
              private kongService: KongService,
              public dialog: MatDialog,
              private _service: ConnecttocrudService,
              private router: Router,
              private location: Location,
              private _route: ActivatedRoute,
              private appComp: AppComponent,
              public platform: LeftpanelComponent,
              private leftPanelDataListener: ListenerService,
              private ngxXml2jsonService: NgxXml2jsonService, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/* this.editor.get()*/);
    iconRegistry.addSvgIcon(
        'video',
        sanitizer.bypassSecurityTrustResourceUrl('/assets/img/video.svg'));
  }
  addnewrow(val) {
    this.addAttributeField(this.apiByDefinition, this.selectDatabase);
  }
  Change() {
    this.ispublished = !this.ispublished;
  }
  addAttributeField(data, database) {
    if (database === 'mongodb' || database === 'default') {
      const newField = {
        'customType': false,
        'apiAccessPolicy': 'None',
        'attributeName': null,
        'type': null,
        'array': false,
        'size': null,
        'precision': null,
        'autoIncrement': false,
        'defaultValue': null,
        'attributeType': 'None',
        'dataStoragePolicy': 'None',
        'description': null,
        'displayName': null,
        'displayPolicy': null,
        'required': false,
        'subType': []
      };
      data.push(newField);
    } else {
      const newField = {
        'customType': false,
        'apiAccessPolicy': 'None',
        'attributeName': null,
        'type': null,
        'size': null,
        'precision': null,
        'autoIncrement': false,
        'defaultValue': null,
        'attributeType': 'None',
        'dataStoragePolicy': 'None',
        'description': null,
        'displayName': null,
        'displayPolicy': null,
        'required': false,
        'subType': []
      };
      data.push(newField);
    }
  }

  omit_special_char(event) {

    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57));
    return(k !== 95);
  }

  typeCheck(definition) {

    const entityAndVersionCheckString = definition.type,
        substring = '_';
    if (entityAndVersionCheckString.includes(substring)) {
      definition.customType = true;
      definition.attributeType = 'DBRef';
      definition.array = true;
    } else {
      definition.customType = false;
      definition.attributeType = 'None';
      definition.array = false;
    }

    if (this.selectDatabase === 'default' || this.selectDatabase === 'mongo') {
      if (definition.type === 'Array' || definition.type === 'Object') {
        this.addAttributeField(definition.subType, this.selectDatabase);
      } else {
        this.removeAttributeField(definition.subType);
      }
    } else {
      if (definition.type === 'Array' || definition.type === 'Object') {
        this.addAttributeField(definition.subType, this.selectDatabase);
      } else {
        this.removeAttributeField(definition.subType);
      }
    }
  }

  removeAttributeField(data) {
    for (var i = 0; i < data.length; i++) {
      data.splice(i, 1);
    }
  }

  removeAttribute(data, index) {
    data.splice(index, 1);
  }

  setPrimaryFlag(i, type) {
    if (type === 'Primary' && this.flagValue) {
      this.flag = i;
      this.flagValue = false;
    } else if (i === this.flag && !this.flagValue && type !== 'Primary') {
      this.flag = null;
      this.flagValue = true;
    }
  }

  onInit(editor) {
    let line = editor.getPosition();

  }

  enableMonaco(ev) {
    if (ev.tab.textLabel.trim() === 'Open API') {
      this.enableMonacoEditor = true;
    }
    if (ev.tab.textLabel.trim() === 'Business Logic') {
      this.enableBlockly = true;
    } else {
      //  this.enableMonacoEditor = false;
    }

  }

  async ngOnInit() {
    this.appComp.currentPageTitle = 'Create Data Access API';
    this.gatewayUrl = await this.platform.getDefaultGatewayURL();
    this.gatewayFullUrl = 'https://' + this.gatewayUrl;
    this.router.events.subscribe(event => {
      this.route = this.location.path();
      if (this.route.includes('/swifter')) {
        this.hideBreadcrumb = true;
      } else {
        this.hideBreadcrumb = false;
      }
    });

    if (this.location.path() !== '') {
      this.route = this.location.path();
      if (this.route.includes('/swifter')) {
        this.hideBreadcrumb = true;
      } else {
        this.hideBreadcrumb = false;
      }
    }

    // this.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'));

    // if (this.platform.entityAndVersion !== null && this.platform.entityAndVersion !== undefined) {
    //   this.entityAndVersion = this.platform.entityAndVersion;
    // } else {
    //   this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
    //         if (response.status === 200) {
    //           this.entityAndVersion = response.body['entityNameAndVersion'];
    //           this.platform.entityAndVersion = this.entityAndVersion;
    //         }
    //       },
    //       error => {
    //         this.platform.openSnackBar('Error while getting entity name and version for partner account: ' + error.error.message, 'Error', {
    //           duration: 15000,
    //           verticalPosition: 'top',
    //           horizontalPosition: 'center'
    //         });
    //       });
    // }

    // this.confPost.getDataTypes().subscribe(data => {
    //   this.datatypes = data;
    // });
    //
    // this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
    //   this.databases = data;
    // });
    if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
      this.datatypes = this.platform.datatypes;
    } else {
      await this.platform.getDataTypesForPartnerAccount();
      this.datatypes = this.platform.datatypes;
    }

    if (this.platform.databases !== null && this.platform.databases !== undefined) {
      this.databases = this.platform.databases;
    } else {
      await this.platform.getDatabasesForPartnerAccount();
      this.databases = this.platform.databases;
    }
    // this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
    //   this.options = data;
    //   this.filteredOptions = this.myControl.valueChanges
    //       .pipe(
    //           startWith<string | ICategory>(''),
    //           map(value => typeof value === 'string' ? value : value.name),
    //           map(name => name ? this._filter(name) : this.options.slice())
    //       );
    // });

    // New Implementation but commented
    // if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
    //   this.options = this.platform.partnerCategories;
    // } else {
    //   this.platform.getCategoriesForPartnerAccount();
    //   this.options = this.platform.partnerCategories;
    // }
    // this.filteredOptions = this.myControl.valueChanges
    //     .pipe(
    //         startWith<string | ICategory>(''),
    //         map(value => typeof value === 'string' ? value : value.name),
    //         map(name => name ? this._filter(name) : this.options.slice())
    //     );

    if (this.platform.countPartnerAccountEntities !== null && this.platform.countPartnerAccountEntities !== undefined) {
      this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
    } else {
      this.platform.getEntityCountForPartnerAccount();
      this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
    }
    if (this.platform.countPartnerEntities !== null && this.platform.countPartnerEntities !== undefined) {
      this.countPartnerEntities = this.platform.countPartnerEntities;
    } else {
      this.platform.getEntityCountForPartner();
      this.countPartnerEntities = this.platform.countPartnerEntities;
    }

    $(document).on('click', '.removeHeader', function () {
      $(this).closest('td').parent('tr').remove();
    });

  }

  // getEntitiesForPartnerAccount(partner, account) {
  //   this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
  //     this.entities = data;
  //     this.entities.forEach(entity => {
  //       this.entityTypes.push(entity.entityname + '_' + entity.version);
  //     });
  //   });
  // }


  async filterDataTypes(val) {
    this.getDatabaseTypeForDatabaseName(val);
    this.dataTypeFilter = [];
    this.datatypes.filter(items => {
      if (items.database_type === this.selectedDatatypeFilter) {
        this.dataTypeFilter.push(items);
      }
    });
    if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
      await this.platform.getCustomTypes(val);
      this.entityAndVersion = this.platform.entityAndVersion;
    } else {
      this.entityAndVersion = [];
    }
    if (this.entityAndVersion) {
      for (let i = 0; i < this.entityAndVersion.length; i++) {
        const newType = {
          'database_type': 'mongodb',
          'data_types': [
            {
              'type': this.entityAndVersion[i],
              'default_length': '',
              'min_length': '',
              'max_length': ''
            }]
        };
        this.dataTypeFilter.push(newType);
      }
    }

    if (this.selectedDatatypeFilter === 'mongodb') {
      this.tableLabelName = 'Collection Name';
    } else {
      this.tableLabelName = 'Table Name';
    }
  }

  getDatabaseTypeForDatabaseName(val) {
    this.databases.filter(items => {
      if (items.database_name === val) {
        this.selectedDatatypeFilter = items.database_type;
      }
    });
  }

  displayFn(user?: ICategory): string | undefined {
    return user ? user.name : undefined;
  }

  displayVersion(version?: EntityVersions): string | undefined {
    return version ? version.name : undefined;
  }

  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const attributeName = clipboardData.getData('text');
    let attributeLength = 0;

    for (let i = 0; i < attributeName.length; i++) {
      if (attributeName.charCodeAt(i) === 8 || attributeName.charCodeAt(i) === 32 || ( attributeName.charCodeAt(i) > 64 && attributeName.charCodeAt(i) < 91) || ( attributeName.charCodeAt(i) > 96 && attributeName.charCodeAt(i) < 123) || ( attributeName.charCodeAt(i) >= 48 && attributeName.charCodeAt(i) <= 57)) {
        attributeLength++;
      }
    }

    if (attributeLength !== attributeName.length) {
      this.isSpecialCharacterInAttribute = true;
    } else {
      this.isSpecialCharacterInAttribute = false;
    }

  }

  createApi() {
    const logTimeStamp = Date.now();
    const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
    if (this.entityName !== undefined && this.entityName !== null && this.entityName.length !== 0 &&
        vers !== undefined && vers !== null && vers.length !== 0 &&
        this.apiCategory !== undefined && this.apiCategory !== null && this.apiCategory.length !== 0 &&
        this.methodType !== undefined && this.methodType !== null && this.methodType.length !== 0 &&
        this.selectDatabase !== undefined && this.selectDatabase !== null && this.selectDatabase.length !== 0 &&
        this.apiByDefinition[0].attributeName !== null) {

      this.save = false;
      const that = this;
      let entityLength = 0;
      let versionLength = 0;

      for (let i = 0; i < this.entityName.length; i++) {
        if (this.entityName.charCodeAt(i) === 8 || this.entityName.charCodeAt(i) === 32 || ( this.entityName.charCodeAt(i) > 64 && this.entityName.charCodeAt(i) < 91) || ( this.entityName.charCodeAt(i) > 96 && this.entityName.charCodeAt(i) < 123) || ( this.entityName.charCodeAt(i) >= 48 && this.entityName.charCodeAt(i) <= 57)) {
          entityLength++;
        }
      }

      for (let i = 0; i < this.version.length; i++) {
        if (this.version.charCodeAt(i) === 8 || this.version.charCodeAt(i) === 32 || ( this.version.charCodeAt(i) > 64 && this.version.charCodeAt(i) < 91) || ( this.version.charCodeAt(i) > 96 && this.version.charCodeAt(i) < 123) || ( this.version.charCodeAt(i) >= 48 && this.version.charCodeAt(i) <= 57)) {
          versionLength++;
        }
      }

      const methods = [];
      this.methodType.forEach(method => {
        methods.push(method.id);
      });

      if (entityLength === this.entityName.length) {
        if (versionLength === this.version.length) {
          // if (!this.isSpecialCharacterInAttribute) {
          this.loading = true;
          const crudAPI = {
            'entityname': this.entityName,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'database': this.selectDatabase,
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'methods': methods,
            'attributes': this.apiByDefinition
          };
          this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            if (data && data['message'] === 'API already exists.') {
              this.save = false;
              this.loading = false;
              this.platform.openSnackBar(data['message'], 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            } else {
              if (this.ispublished) {
                this.Blocks = [1, 2, 3, 4, 5];
                const blockLength = this.Blocks.length;
                const blockStart = this.BlockList[this.Blocks[0]];
                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                this.progress = blockStart;
                this.save = true;
                that.setInterval(blockEnd, true);
                this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                  // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
                  this.platform.apiExecutors = data;
                  // localStorage.setItem('isDataAccessAPISet', 'true');
                  this.platform.isDataAccessAPISet = 'true';
                  // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
                  this.platform.updatedDataAccessAPI = JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']});
                });
              } else {
                this.Blocks = [1, 2, 3];
                this.save = true;
                const blockLength = this.Blocks.length;
                const blockStart = this.BlockList[this.Blocks[0]];
                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                this.progress = blockStart;
                that.setInterval(blockEnd, true);
                this.leftPanelDataListener.changeInLeftPanelData.emit('update');
              }
            }
          }, error => {
            this.save = false;
            // this.ispublished = false;
            this.loading = false;
            // this.platform.openSnackBar('Error while adding Entity', 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
            const dialogRef = this.dialog.open(DialogComponent, {
              data: {title: 'Error while Creating', message: error.error.message}
            });
          });
          if (this.ispublished) {
            // this.configureApiGateway();
            this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false, methods, Date.now(), '');
          }

          // } else {
          //     this.platform.openSnackBar('Special characters are not allowed in attribute name', 'Error', {
          //         duration: 5000,
          //         verticalPosition: 'top',
          //         horizontalPosition: 'center'
          //     });
          // }
        } else {
          this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      } else {
        this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {

      if (this.entityName === undefined || this.entityName === '' || this.entityName === null || this.entityName.length === 0) {
        this.platform.openSnackBar('Please enter a valid name for Data Access Service', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (vers === undefined || vers === '' || vers === null || vers === 0) {
        this.platform.openSnackBar('Please enter a valid version for Data Access Service', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (this.apiCategory === undefined || this.apiCategory === '' || this.apiCategory === null || this.apiCategory.length === 0) {
        this.platform.openSnackBar('Please enter a valid category for Data Access Service', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (this.selectDatabase === undefined || this.selectDatabase === null || this.selectDatabase.length === 0) {
        this.platform.openSnackBar('Please select a database to create this service', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (this.methodType === undefined || this.methodType === [] || this.methodType === null || this.methodType.length === 0) {
        this.platform.openSnackBar('You need to select at least one Method Type to create this service', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else if (this.apiByDefinition[0].attributeName === null) {
        this.platform.openSnackBar('You need to select at least one Attribute to create this service', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }


  }
  getXML() {
    const that = this;
    // xml = `<note><to>User</to><from>Library</from><heading>Message</heading><body>Some XML to convert to JSON!</body></note>`;
    const xml1 = $('.getXML').val().replace(/\s/g, '').trim();
    const parser = new DOMParser();
    const xml = parser.parseFromString(xml1, 'text/xml');
    const obj = this.ngxXml2jsonService.xmlToJson(xml);
    const crudAPI = {
      'entityname': that.entityName,
      'category': ((typeof that.apiCategory) === 'object' ? that.apiCategory['name'] : that.apiCategory),
      'displayname': that.displayName,
      'description': that.description,
      'scopeOfAccess': that.scopeSelected,
      'database': that.selectDatabase,
      'version': ((typeof that.version) === 'object' ? that.version['name'] : that.version),
      'attributes': obj
    };
    that.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      that.platform.openSnackBar('Entities Added successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      that.showNextPanel = true;

    }, error => {
      that.platform.openSnackBar('Error while adding Entity', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  createApiFromYaml() {
    this.confPost.createAPIFromYaml(localStorage.getItem('partner'), localStorage.getItem('account'), this.yamlData).subscribe(data => {
      this.platform.openSnackBar('APIs have been created from YAML successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.showNextPanel = true;

    }, error => {
      this.platform.openSnackBar('Error while creating APIs from YAML', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  getJSON() {
    this.loading = true;
    this.save = false;
    const that = this;
    const crudAPI = {
      'entityname': this.entityName,
      'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
      'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
      'displayname': this.displayName,
      'description': this.description,
      'scopeOfAccess': this.scopeSelected,
      'database': this.selectDatabase,
      'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
      'attributes': this.editor.get()
    };
    this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      if (data && data['message'] == 'API already exists.') {
        this.save = false;
        this.loading = false;
        this.platform.openSnackBar(data['message'], 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else {
        if (this.ispublished) {
          this.Blocks = [1, 2, 3, 4, 5];
          const blockLength = this.Blocks.length;
          const blockStart = this.BlockList[this.Blocks[0]];
          const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
          this.progress = blockStart;
          this.save = true;
          that.setInterval(blockEnd, true);
        } else {
          this.Blocks = [1, 2, 3];
          this.save = true;
          const blockLength = this.Blocks.length;
          const blockStart = this.BlockList[this.Blocks[0]];
          const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
          this.progress = blockStart;
          that.setInterval(blockEnd, false);
        }
      }

    }, error => {
      this.platform.openSnackBar('Error while adding Entity', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
    if (this.ispublished) {
      // this.configureApiGateway();
      this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false);
    }
  }

  addHeaders() {
    const tr = '<tr>\n' +
        '              <td>\n' +
        '                <input type="text" placeholder="key" class="form-control">\n' +
        '              </td>\n' +
        '              <td>\n' +
        '                <input type="text" placeholder="value" class="form-control">\n' +
        '              </td>\n' +
        '              <td>\n' +
        '                <i class="fa fa-minus-square removeHeader"></i>\n' +
        '              </td>\n' +
        '            </tr>';
    $('#APIheader').find('tbody').append(tr);
  }

  copyMessage(val) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = $(val).text();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    alert('CURL command copied to clipboard');
  }

  getAPI() {
    const that = this;
    this.loading = true;
    this.save = false;
    this.buttonClick = true;
    this.error = false;
    const APIUrl = $('#APIUrl').val();
    const dataroot = $('#dataroot').val();
    const Header = [];
    Header.push({
      'Content-Type': 'application/json'
    });
    $('#APIheader').find('tbody').find('tr').each(function () {
      const header = {};
      if ($(this).find('td:first').find('input').val().trim() !== '') {
        header[$(this).find('td:first').find('input').val().trim()] = $(this).find('td:eq(1)').find('input').val().trim();
        Header.push(header);
      }
    });
    const crudAPI = {
      'entityname': this.entityName,
      'importData': this.importData,
      'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
      'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
      'displayname': this.displayName,
      'description': this.description,
      'published': this.ispublished,
      'scopeOfAccess': this.scopeSelected,
      'database': (this.selectDatabase === null ? 'default' : this.selectDatabase),
      'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
      'APIUrl': APIUrl,
      'dataroot': dataroot,
      'Header': Header
    };
    this.confPost.createAPI(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      if (data && data['message'] == 'API already exists.') {
        this.save = false;
        this.loading = false;
        this.platform.openSnackBar(data['message'], 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      } else {
        if (this.ispublished) {
          this.Blocks = [1, 2, 3, 4, 5];
          const blockLength = this.Blocks.length;
          const blockStart = this.BlockList[this.Blocks[0]];
          const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
          this.progress = blockStart;
          this.save = true;
          that.setInterval(blockEnd, true);
          //  setInterval(() => this.manageProgress(blockEnd, false), 1000);
        } else {
          this.Blocks = [1, 2, 3];
          this.save = true;
          const blockLength = this.Blocks.length;
          const blockStart = this.BlockList[this.Blocks[0]];
          const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
          this.progress = blockStart;
          that.setInterval(blockEnd, false);
          // setInterval(() => this.manageProgress(blockEnd, false), 1000);
          /* this.platform.openSnackBar('API has been created successfully', 'Success', {
               duration: 5000,
               verticalPosition: 'top',
               horizontalPosition: 'center'
           });*/
        }
      }
    }, error => {
      this.APILoading = true;
      this.error = true;
      this.platform.openSnackBar(error.error.message, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });

    if (this.ispublished) {
      // this.configureApiGateway();
      this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false);

    }
  }

  navigateDataView() {
    this.router.navigate(['/api'],
        {
          queryParams: {
            partner: localStorage.getItem('partner'),
            account: localStorage.getItem('account'),
            entity: this.entityName,
            version: this.version['name']
          }
        });
  }

  navigateAPIReview() {
    this.router.navigate(['/entity/edit'],
        {
          queryParams: {
            partner: localStorage.getItem('partner'),
            account: localStorage.getItem('account'),
            entity: this.entityName,
            version: this.version['name']
          }
        });
  }

  toggleExecutor(ev) {
    $('.executor-definition').slideToggle();
    $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
  }

  manageProgress(target, showPanel) {
    // if (this.progress <= target) {
    // this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
    //   let item = data;
      // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
        // let apiKey = keys['data'][0].key;
        let apiKey = localStorage.getItem('apikey');
        const dialogRef = this.dialog.open(DialogComponent, {
          maxWidth: '95vw',
          data: {type: 'dataaccess', save: true, ispublished: this.ispublished, gatewayFullUrl: this.gatewayFullUrl, Blocks: this.Blocks, version: this.version, showNextPanel: false, partner: this.partner, account_id: this.account_id, entity: this.entityName, apiKey: apiKey, partnerKey: this.partnerKey}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result === 'create') {
            window.location.reload();
          } else if (result === 'edit') {
            this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
          } else if (result === 'data') {
            this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
          } else if (result === 'devex') {
            this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
          }
        });
      // });
    // });
    // this.showNextPanel = showPanel;
    this.loading = false;
    this.ngOnDestroy();
    // } else {
    //     this.progress = this.progress + incr;
    // }
    // if (this.progress <= 35) {
    //     this.progressMessage = 'Setting Up API';
    // } else if (this.progress > 35 && this.progress <= 70) {
    //     this.progressMessage = 'Setting Up Database';
    //     /*} else if (this.progress > 70 && this.progress <= 98) {
    //         this.progressMessage = 'Creating dedicated File storage for your account';*/
    // } else if (this.progress > 70) {
    //     this.progressMessage = 'Deploying into Cloud';
    // }
  }
  manageProgressForApi() {
    if (this.progress >= 100) {
      // this.APILoading = true;
      this.showNextPanel = true;
    } else {
      this.progress = this.progress + incr;
    }
    if (this.progress <= 35) {
      this.progressMessage = 'Setting Up API & Schema';
    } else if (this.progress > 35 && this.progress <= 70) {
      this.progressMessage = 'Setting Up Data';
    } else if (this.progress > 70) {
      this.progressMessage = 'Deploying into Cloud';
    }
  }

  createAPIByDB() {
    this.buttonClickdB = true;
    this.dberror = false;
    const crudAPI = {
      'database_name': this.databaseName,
      'listOfTables': this.listofTables,
      'useReferentialKeys': this.useReferentialKeys,
      'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
      'importData': this.importDataDB
    };
    this.confPost.createAPIFromDB(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
      this.platform.openSnackBar('API Created successfully', 'Success', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.APILoadingdB = true;

    }, error => {
      this.dberror = true;
      this.APILoadingdB = true;
      this.platform.openSnackBar(error.error.message, 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    });
  }

  openAttributeDescriptionDialog(definition) {
    const data = {
      'displayName': definition.displayName,
      'description': definition.description,
      'dataStoragePolicy': definition.dataStoragePolicy,
      'apiAccessPolicy': definition.apiAccessPolicy,
      'displayPolicy': definition.displayPolicy
    };
    const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      this.accept = result;
      definition.displayName = data.displayName;
      definition.description = data.description;
      definition.dataStoragePolicy = data.dataStoragePolicy;
      definition.apiAccessPolicy = data.apiAccessPolicy;
      definition.displayPolicy = data.displayPolicy;
    });
  }

  private _filter(name: string): ICategory[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  private _versionFilter(name: string): EntityVersions[] {
    const filterValue = name.toLowerCase();

    return this.entityVersions.filter(version => version.name.toLowerCase().indexOf(filterValue) === 0);
  }

  getRegion(val) {
    return this.platform.getRegion(val);
  }

  setInterval(blockEnd, nextPanel) {
    this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
  }

  ngOnDestroy() {
    clearInterval(this.destroy);
  }

  generateExecutorAgain() {
    window.location.reload();
  }

  createMarginRight() {
    document.getElementById('view:json_schema').style.marginRight = '400px';
  }

  removeMarginRight() {
    document.getElementById('view:json_schema').style.marginRight = '0px';
  }
}

